<template>
  <div>
    <a-modal
      title="查看夜审信息"
      :maskClosable="false"
      v-model="visible"
      width="1000px"
    >
      <data-table ref="dataTable" :option="option" class="dataTable">
      </data-table>
      <template slot="footer">
        <a-button @click="onCancel">关闭</a-button>
        <a-button type="primary" @click="onRestartApp">重启IIS站点</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { resetRouter } from "@/router/index";
import { DataTable } from "@/components/dataTable";
import { cache, jump } from "@/utils/common";
import { mapActions } from "vuex";
export default {
  components: {
    DataTable
  },
  data() {
    return {
      visible: false,
      option: {}
    };
  },
  created() {
    this.option = {
      grid: {
        api: "NightCheckInfo",
        autoLoad: false,
        dataField: "Data",
        pagination: false,
        props: {
          autoLoad: false,
          scroll: { x: false, y: window.document.body.clientHeight / 2 }
        },
        columns: [
          {
            title: "序号",
            width: "6%",
            align: "center",
            type: "indexcolumn"
          },

          {
            title: "门店编码",
            width: "150px",
            dataIndex: "CompanyCode"
          },
          {
            title: "门店名称",
            dataIndex: "CompanyName"
          },
          {
            title: "夜审操作员",
            width: "150px",
            dataIndex: "UserCode"
          },
          {
            title: "夜审状态",
            width: "100px",
            dataIndex: "StatusName"
          },
          {
            title: "开始时间",
            width: "150px",
            dataIndex: "BeginTime"
          }
        ]
      }
    };
  },
  methods: {
    ...mapActions(["setMenus"]),
    onShow() {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.dataTable.reload();
      });
    },
    onCancel() {
      this.visible = false;
    },
    onRestartApp() {
      const that = this;
      that.$confirm({
        title: "确定重启IIS站点吗？",
        onOk: () => {
          that.$get("RestartApp", { now: 1 }).then(() => {
            that.$info({
              title: "重启成功，请返回重新登录",
              onOk: () => {
                cache.remove("user");
                cache.remove("LogInfo");
                cache.remove("isFirstIn");
                cache.remove("isNoRemindAuditRemind");
                that.setMenus([]);
                resetRouter();
                jump("login");
              }
            });
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.dataTable {
  min-height: 50vh !important;
  height: 50vh;
}

.text-hide {
  display: inline-block;
  width: 400px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
